import React from 'react';
import { getDisplayDate } from 'src/app/common/utils/time-utils';
import { regionLocale } from 'src/app/i18n';

interface tableConfigType {
  title: string;
  prop: string;
  align?: any;
  render?: any;
  minWidth?: number;
  sorter?: boolean | false;
}

const getNameFromI18nData = (code: string, row: any) => {
  const data = row.i18nDataList.find((item: any) => {
    return item.lang === code;
  });

  return data?.name;
};

const getNameColumns = (Translation: any) => {
  let namesColumns = regionLocale.map((code) => {
    const lang = Translation('navBar.lang.' + code);
    const nameColumn = {
      title: `${Translation('component.formLabel.category')} (${Translation(`navBar.lang.${code}`)})`,
      prop: `i18n_name_${code}`,
      sorter: true,
      render: (row: any) => <span>{getNameFromI18nData(code, row)}</span>,
    };

    return nameColumn;
  });

  return namesColumns;
};

const tableConfig = (Translation: any, i18ConfigData: any): tableConfigType[] => {
  if (i18ConfigData.length === 0) {
    return [];
  }

  const namesColumns = getNameColumns(Translation);

  return [
    {
      title: Translation('component.formLabel.category'),
      prop: 'name',
    },
    {
      title: Translation('component.formLabel.description'),
      prop: 'description',
    },

    {
      title: Translation('component.formLabel.last-updated-time'),
      sorter: true,
      prop: 'updatedAt',
      render: (row: any) => <span>{getDisplayDate(row.updatedAt, 'YYYY-MM-DD HH:mm')}</span>,
    },
  ];
};

export default tableConfig;
